export default "__VITE_ASSET__y2uCqKB6__"